(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('PerfilFlotaListController', PerfilFlotaListController);


    PerfilFlotaListController.$inject = [
        '$templateCache',
        '$scope',
        '$rootScope',
        '$timeout',
        '$state',
        'perfilFlotaService',
        'notificationService'
    ];



    function PerfilFlotaListController( $templateCache,
        $scope,
        $rootScope,
        $timeout,
        $state,
        perfilFlotaService,
        notificationService) {
        // jshint maxstatements:false

        /* PRIVATE VARIABLES */
        var templates = {
			accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/generic/accionesCellTemplate.html'),
			rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html'),
        };

        var vm = this;

        $scope.gridData = [];
        
        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,
            enableRowSelection: true,
            multiSelect: true,
            enableColumnResizing: true,
            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,
            virtualizationThreshold: 200,
			primaryKey: 'perfilFlotaId',
            columnDefs: [            
				{
					name: 'descripcion',
					displayName: 'Descripción',
					resizable: true
				},				
                {
                    field: 'actions',
                    displayName: 'Acciones',
                    width: 100,
                    resizable: true,
                    cellClass: 'overflow',
					cellTemplate: templates.accionesCellTemplate,
					enableSorting: false
                }

            ],
            data: 'gridData',
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;                                         
            }
		};

		vm.selectAll = selectAll;
		vm.clearAll = clearAll;
        vm.invertSelection = invertSelection;
        vm.selectOrClear = selectOrClear;
		vm.goToEdit = goToEdit;
		vm.deleteAllItems = deleteAllItems;
		vm.refreshGrid = refreshGrid;
		vm.remove = remove;

        vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('perfilflota')];

        (function () {
			loadData();
        })();

		$scope.$on('detail-resize', function (event, args) {
            if (vm.tab.isActive()) {
                $timeout(function () { vm.gridApi.core.handleWindowResize(); }, 0);
            }
		});
		
        function loadData() {
            perfilFlotaService.getList()
				.then(function (result) {
					
					$scope.gridData = result.data;
					vm.gridData = result.data;
				});
        }

        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }
        function clearAll() {
            vm.gridApi.selection.clearSelectedRows();
        }
        function invertSelection() {
            var selected = vm.gridApi.selection.getSelectedRows();

            vm.selectAll();

            for (var i = 0; i < selected.length; i++) {
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }
        function selectOrClear() {
            if (vm.gridApi.selection.getSelectAllState()) {
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }


		function goToEdit(perfil) {
			$state.go('flota.perfilflota.editar', { 'id': perfil.perfilFlotaId });
		}

		function remove(perfil) {
			perfilFlotaService.deleteById([perfil.perfilFlotaId]).then(function () {
				loadData();
			});
		}

		function deleteAllItems() {
			var ids = [];
			var selected = vm.gridApi.selection.getSelectedRows();
			for (var i = 0; i < selected.length; i++) {
				ids.push(selected[i].perfilFlotaId);
            }
			perfilFlotaService.deleteById(ids).then(function () {
                refreshGrid();
            });
		}		

		function refreshGrid() {
			loadData();
		}
    }
})();
